import { Component, computed, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ButtonModule } from 'carbon-components-angular/button';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-account-blocked',
  imports: [ButtonModule],
  templateUrl: './account-blocked.component.html',
  styleUrl: './account-blocked.component.scss',
})
export class AccountBlockedComponent {
  private readonly auth = inject(AuthService);
  private readonly route = inject(ActivatedRoute);

  protected readonly message = computed(() => {
    const reason = this.route.snapshot.queryParamMap.get('reason');
    if (reason === 'unmapped') {
      return 'Your account does not have access to this workspace. Contact an administrator.';
    }
    return 'This account is turned off. Contact an administrator.';
  });

  protected logout(): void {
    void this.auth.logout();
  }
}
